export default __webpack_public_path__ + "static/media/hht2_storybook_20.9c2b1412.png";